import { mergeClasses } from '@fluentui/react-components';

import CardBackgroundContent from 'src/components/atoms/card-background-content/CardBackgroundContent';
import CardLayoutContainer from 'src/components/molecules/card-layout-container/CardLayoutContainer';
import { BaseCardLayoutProps } from 'src/ui-models/cardLayout';
import { useCardFullColorLayoutStyles } from './CardFullColorLayout.styles';

interface CardFullColorLayoutProps extends BaseCardLayoutProps {
  category?: string
  color?: string
}

const CardFullColorLayout: React.FC<CardFullColorLayoutProps> = ({ category, color, headline, body, className }) => {
  const styles = useCardFullColorLayoutStyles();
  const fullColorStyle = color && { background: color };
  const backgroundStyle: React.CSSProperties = fullColorStyle || {};
  const classes = mergeClasses(
    'card-full-color-layout',
    styles.textColor,
    !color && styles.defaultBackgroundColor,
    className,
  );
  const cardHeader = category && (
    <span data-testid="category-text" className={styles.categoryText}>
      {category}
    </span>
  );

  return (
    <CardLayoutContainer className={classes} style={backgroundStyle} header={cardHeader}>
      <CardBackgroundContent headline={headline} body={body} />
    </CardLayoutContainer>
  );
};

export default CardFullColorLayout;
